export default "__VITE_ASSET__b_vO$x$o__"